import React, { FC } from 'react';

import { Box, HStack, Text } from '@rbilabs/universal-components';
import { usePaymentContext } from 'features/payment';
import { IPaymentMethod } from 'features/payment/types';
import { useIntl } from 'react-intl';

import Currency from 'components/currency';
import { theme } from 'styles/configure-theme';

interface IPrepaidMethodBalance {
  method: IPaymentMethod;
  isDisabled?: boolean;
  isRedesign?: boolean;
}

const PrepaidMethodBalance: FC<IPrepaidMethodBalance> = ({
  method,
  isDisabled = false,
  isRedesign = false,
}) => {
  const { getBalanceFromPaymentMethods } = usePaymentContext();
  const { formatMessage } = useIntl();

  if (isRedesign) {
    return (
      <Box alignItems="flex-start" flexDirection="column">
        <Text
          color={isDisabled ? theme.token('text-disabled') : theme.token('text-default')}
          variant="headerTwo"
          fontSize="lg"
          mb="$1"
        >
          {formatMessage({ id: 'giftCard' })}
        </Text>
        <Currency
          amount={getBalanceFromPaymentMethods(method)}
          textProps={{
            margin: 0,
          }}
        />
      </Box>
    );
  }

  return (
    <HStack space="$2" alignItems="center">
      <Text color={isDisabled ? theme.token('text-disabled') : theme.token('text-default')}>
        {formatMessage({ id: 'giftCard' })}
      </Text>
      <Currency
        amount={getBalanceFromPaymentMethods(method)}
        textProps={{
          margin: 0,
        }}
      />
    </HStack>
  );
};

export default PrepaidMethodBalance;
